import { useState } from "react";
import axios from "axios";
import api from "@/store/api";
import { getData } from "@/lib/utils";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

const useOrder = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [loading, setloading] = useState(false);
  const [isOrderLoading, setIsLoading] = useState(false);
  const [Ordererror, setError] = useState<string | null>(null);
  const [error, setErrorOrder] = useState<string | null>(null);

  const createOrder = async (orderData: any) => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.post("/web/orders/upsert", orderData, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }); // Update the endpoint as needed
      return response.data;
    } catch (err) {
      const message =
        axios.isAxiosError(err) && err.response?.data?.message
          ? err.response.data.message
          : t("alerts.error.unexpectedError");
      setError(message);
      return { success: false, error: message };
    } finally {
      setIsLoading(false);
    }
  };
  const updateOrder = async (orderData: any) => {
    setIsLoading(true);
    setError(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.post("/web/orders/upsert", orderData, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }); // Update the endpoint as needed
      return response.data;
    } catch (err) {
      const message =
        axios.isAxiosError(err) && err.response?.data?.message
          ? err.response.data.message
          : t("alerts.error.unexpectedError");
      setError(message);
      return { success: false, error: message };
    } finally {
      setIsLoading(false);
    }
  };
  const fetchOrders = async (companyId: String) => {
    setloading(true);
    setErrorOrder(null);
    try {
      const response = await api.get(
        `/web/orders/getAll?pageSize=10&pageNumber=1&withPaging=false&companyId=${companyId}`
      );
      setloading(false);
      return response.data;
    } catch (err) {
      setloading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          // Offer not found, return null instead of throwing an error
          return null;
        }
        setErrorOrder(
          err.response?.data?.message || t("alerts.error.fetchOrder")
        );
      } else {
        setErrorOrder(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const fetchBuyerOrders = async (companyId: String) => {
    setloading(true);
    setErrorOrder(null);
    try {
      const response = await api.get(
        `/web/orders/getAllBuyer?pageSize=10&pageNumber=1&withPaging=false&companyId=${companyId}`
      );
      setloading(false);
      return response.data;
    } catch (err) {
      setloading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          // Offer not found, return null instead of throwing an error
          return null;
        }
        setErrorOrder(
          err.response?.data?.message || t("alerts.error.fetchOrder")
        );
      } else {
        setErrorOrder(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  const fetchOrderById = async (OrderId: String) => {
    setloading(true);
    setErrorOrder(null);
    try {
      let Token = getData("tokens")?.accessToken;
      const response = await api.get(`/web/orders/get?id=${OrderId}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setloading(false);
      return response.data;
    } catch (err) {
      setloading(false);
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 404) {
          // Offer not found, return null instead of throwing an error
          return null;
        }
        setErrorOrder(err.response?.data?.message || t("orders.fetchById"));
      } else {
        setErrorOrder(t("alerts.error.unexpectedError"));
      }
      throw err;
    }
  };
  return {
    createOrder,
    fetchOrders,
    fetchBuyerOrders,
    fetchOrderById,
    updateOrder,
    isOrderLoading,
    Ordererror,
    loading,
    error,
  };
};

export default useOrder;
